export const HOME = "/";
export const PROFILE = "/profile";
export const USERPAGE = "/userpage";
export const PLAYLISTS = "/playlists";
export const ABOUT = "/about";